import { useTranslation } from "@impero-com/common/utils/i18n";
import { Outlet, useMatch, useParams } from "react-router-dom";

import { ErrorBoundary } from "components/errorBoundary";

import { Body } from "../body";

import {
    findUserSubpath,
    USER_ID_PATH,
    USER_VIEW_DEFAULT_TITLE,
} from "./userRoutes";

/**
 * Layout for /users/:id and its sub-pages. Each page renders its own
 * `UserViewPage`, so the page decides which actions the app bar shows.
 */
export function UserViewLayout() {
    const segment =
        useMatch(`${USER_ID_PATH}/:segment/*`)?.params.segment ?? "";
    const titleKey = findUserSubpath(segment)?.title ?? USER_VIEW_DEFAULT_TITLE;
    const { id = "" } = useParams();
    const { t } = useTranslation();
    return (
        <Body title={t(titleKey)} navId="userManagement" routerLinks>
            {/* Catches the errors of UserViewPage itself, which take the gray
                menu down with it. Errors of the content inside it are caught
                by UserViewPage, so the menu stays. */}
            <ErrorBoundary routeKey={id}>
                <Outlet />
            </ErrorBoundary>
        </Body>
    );
}
